<template>
  <IModal text-cancel="いいえ" text-ok="変更する" :with-action-button="true" @ok="onOk">
    <h3 :class="$style.title">カート内の購入オプションを変更しますか？</h3>
    <p :class="$style.message">同じ作品内で異なるオプションは同時に購入できません。こちらのオプションに変更しますか？</p>
    <template #footer>
      <p :class="$style.footer">※ 異なるオプションも購入されたい場合、別途ご注文ください。</p>
    </template>
  </IModal>
</template>

<script setup lang="ts">
import { addToBasket, removeFromBasket } from '@/js/lib/api/v1/cart';
import { useCartStore } from '@/js/lib/store/cart';
import { useCommonStore } from '@/js/lib/store/common';
import { info } from '@/js/lib/ui';
import { mountModal } from '@/js/lib/ui/helper/dynamic-modal';
import IModal from '@/js/components/molecules/IModal.vue';
import CartModal from './CartModal.vue';

const { isWebView } = useCommonStore();
const cartStore = useCartStore();

const props = defineProps<{
  itemId: number;
  itemOptionVariantSlugs: string[];
}>();

const onOk = async () => {
  try {
    await removeFromBasket({ itemId: props.itemId });
    await addToBasket({ itemId: props.itemId, itemOptionVariantSlugs: props.itemOptionVariantSlugs });

    // 以前のeコマースオブジェクトをクリアする
    // eslint-disable-next-line unicorn/no-null
    window.dataLayer?.push({ ecommerce: null });
    // eslint-disable-next-line unicorn/prefer-single-call
    window.dataLayer?.push({
      event: 'add_to_cart',
      ecommerce: {
        items: [
          {
            item_id: props.itemId,
            quantity: 1,
          },
        ],
      },
    });

    if (isWebView) {
      info('カートの内容を変更しました', { fadeOut: true });
      return;
    }
    await cartStore.loadBaskets();
    mountModal({
      Component: CartModal,
      props: {
        text: 'カートの内容を変更しました',
      },
    });
  } catch (error) {
    window.Sentry?.captureException(error);
    if (error?.response?.data?.errors.includes('stock_missing')) {
      info('注文個数が在庫数を超えています');
    } else {
      info('カートの内容を変更できませんでした');
    }
  }
};
</script>

<style module lang="scss">
.title {
  font-size: 18px;
  font-weight: bold;
  margin: 0 0 20px;
}

.message {
  text-align: left;
}

.footer {
  color: var(--color-gray800);
  font-size: 12px;
}
</style>
